import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IAdminNotification } from '../../../../../../../common/common-interfaces/admin-notification';
import { Api } from '../../../services/api';
import { Globals } from '../../../services/globals';
import { Utility } from 'src/app/services/utility';
import { NgZone } from '@angular/core';
import { IPosterOrder } from '../../../../../../../common/common-interfaces/poster-order';
import moment from 'moment';
import { IGlobalSettings } from '../../../../../../../common/common-interfaces/global-settings';
import { allAvailableSKUs } from '../../../../../../../common/common-helpers/sku';

@Component({
    selector: 'admin-overview',
    templateUrl: './admin-overview.component.html',
    styleUrls: ['./admin-overview.component.scss'],
    standalone: false
})
export class AdminOverviewComponent {
    orderIssues: any;
    overdueOrders: IPosterOrder[] = [];
    productionIssueOrders: IPosterOrder[] = [];
    ordersWithDeliveryIssues: number = 0;
    ordersWithProductionIssues: number = 0;
    showSentOrderIssues: boolean = false;

    settings: IGlobalSettings;
    skusWithoutPrices: string[];


    constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals, public utility: Utility, private zone: NgZone) {

    }

    async ngOnInit() {
        await this.refreshIssues();
        this.settings = await this.api.admin().get<any>(`/settings`);
        await this.checkSKUPrices();
    }


    async refreshIssues() {
        this.orderIssues = await this.api.admin().get<any>(`/poster-orders/issues`);
        await this.showSentOrderIssuesChanged();
    }

    async checkSKUPrices() {
        this.skusWithoutPrices = [];
        for (let sku of allAvailableSKUs) {
            if (!this.settings.defaultCreditPrices[sku])
                this.skusWithoutPrices.push(sku);
        }
    }


    async markOrderAsDelivered(order: IPosterOrder) {
        let result = await this.api.storeId(order.storeId).post(`/poster-orders/${order._id}/mark-as-delivered`, {});
        let orderIndex = this.orderIssues.overdueOrders.indexOf(order);
        if (orderIndex > -1) {
            this.orderIssues.overdueOrders.splice(orderIndex, 1);
        }

        let productionOrderIndex = this.orderIssues.productionIssueOrders.indexOf(order);
        if (productionOrderIndex > -1) {
            this.orderIssues.productionIssueOrders.splice(productionOrderIndex, 1);
        }
        this.showSentOrderIssuesChanged();
    }

    getOrderFulfillmentPartners(order: IPosterOrder) {
        let result = {};
        for (let item of order.items) {
            result[item.fulfillmentPartner] = true;
        }
        return Object.keys(result);
    }

    getOrderProductionConfirmations(order: IPosterOrder) {
        let result = [];
        for (let item of order.items) {
            if (item.fulfillmentPartner == 'EXAKTA') {
                if (item.productionConfirmed) {
                    result.push(moment(item.productionConfirmedDate).format('YYYY-MM-DD HH:mm'));
                }
                else {
                    result.push(null);
                }
            }
        }
        return result;
    }

    getOrderProductionDays(order: IPosterOrder) {
        if (!order.metadata || !order.metadata.queuedForPrintDate)
            return '-';

        let date = moment();

        if (order.metadata && order.metadata.dispatchDate)
            date = moment(order.metadata.dispatchDate)

        let days = 0;

        while (date.isAfter(moment(order.metadata.queuedForPrintDate))) {
            if (date.day() !== 0 && date.day() !== 6) {
                days++;
            }
            date.subtract(1, 'days');
        }

        return `${days} vardagar`;
    }

    getOrderTotalDeliveryDays(order: IPosterOrder) {
        let date = moment();
        let days = 0;

        while (date.isAfter(moment(order.created))) {
            if (date.day() !== 0 && date.day() !== 6) {
                days++;
            }
            date.subtract(1, 'days');
        }

        return `${days} vardagar`;
    }



    async showSentOrderIssuesChanged() {
        if (this.showSentOrderIssues) {
            this.overdueOrders = this.orderIssues.overdueOrders;
        }
        else {
            this.overdueOrders = this.orderIssues.overdueOrders.filter(o => !o.metadata || !o.metadata.dispatchDate);
        }
        this.productionIssueOrders = this.orderIssues.productionIssueOrders;

        this.ordersWithDeliveryIssues = this.overdueOrders.length;
        this.ordersWithProductionIssues = this.productionIssueOrders.length;
    }

}
